var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
import React, { useState, useEffect } from 'react';
import NxDropdown from '../NxDropdown';
import { propTypes } from './types';
var NxStatefulDropdown = function NxStatefulDropdown(props) {
    var _a = useState(false), isOpen = _a[0], toggleOpen = _a[1], onToggleCollapse = function () { toggleOpen(!isOpen); };
    var handleKeyPress = function (event) {
        if (event.key === 'Escape') {
            toggleOpen(false);
        }
    };
    var handleClick = function () {
        // Effects get re-executed after every render.
        // A consequence of this is that the `handleClick` function bound to
        // document.onclick will have values from the closure of the previous render.
        // So for instance, while handling the click that opens the menu
        // the value of `isOpen` will be that of the previous render: false.
        // Something that we're depending on to avoid closing the menu when
        // it is just opening.
        if (isOpen) {
            toggleOpen(false);
        }
    };
    useEffect(function () {
        document.addEventListener('click', handleClick);
        return function cleanup() {
            document.removeEventListener('click', handleClick);
        };
    });
    return (React.createElement(NxDropdown, __assign({ isOpen: isOpen, onToggleCollapse: onToggleCollapse, onKeyDown: handleKeyPress }, props)));
};
NxStatefulDropdown.propTypes = propTypes;
export default NxStatefulDropdown;
export { propTypes } from './types';
//# sourceMappingURL=NxStatefulDropdown.js.map